import React from "react";

interface IconProps {
  width?: string;
  height?: string;
  color?: string;
  fillColor?: string;
  onClick?: () => void;
}

const FioFidCardIcon: React.FC<IconProps> = ({
  width = "30",
  height = "30",
  color = "#EE8113",
  fillColor = "white",
  ...props
}) => (
  <svg
    width={width}
    height={height} 
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_449_2841)">
      <path
        d="M23.122 12C23.122 5.70393 18.1425 0.599976 12 0.599976C5.85752 0.599976 0.878052 5.70393 0.878052 12C0.878052 18.296 5.85752 23.4 12 23.4C18.1425 23.4 23.122 18.296 23.122 12Z"
        fill={fillColor}
      />
      <path
        d="M23 12C23 5.94886 18.0751 1.04346 12 1.04346C5.92487 1.04346 1 5.94886 1 12C1 18.0511 5.92487 22.9565 12 22.9565C18.0751 22.9565 23 18.0511 23 12Z"
        stroke={color}
      />
      <g clipPath="url(#clip1_449_2841)">
        <path
          d="M17.4921 10.6189C17.7441 10.3647 17.833 9.99165 17.7243 9.64533C17.6156 9.29901 17.3318 9.05136 16.9836 8.99902L13.9393 8.54115C13.8795 8.53218 13.8279 8.49333 13.8011 8.43725L12.4397 5.58201C12.284 5.25546 11.9687 5.05261 11.6169 5.05261C11.2651 5.05261 10.9498 5.25546 10.7941 5.58201L9.43264 8.43728C9.40587 8.49333 9.35423 8.53218 9.29446 8.54118L6.25017 8.99902C5.90201 9.05136 5.61823 9.29901 5.50948 9.64533C5.40073 9.99165 5.48969 10.3647 5.74166 10.6189L7.94454 12.8414C7.98778 12.885 8.00754 12.9479 7.99732 13.0095L7.47728 16.1478C7.41782 16.5067 7.55766 16.8626 7.84229 17.0766C8.12691 17.2907 8.49725 17.3183 8.80861 17.1489L11.5315 15.6673C11.585 15.6382 11.6488 15.6382 11.7023 15.6673L14.4252 17.1489C14.5607 17.2226 14.7073 17.259 14.8531 17.259C15.0425 17.259 15.2307 17.1976 15.3915 17.0766C15.6761 16.8625 15.816 16.5066 15.7565 16.1477L15.2364 13.0095C15.2262 12.9479 15.246 12.885 15.2892 12.8414L17.4921 10.6189ZM14.513 13.138L15.0331 16.2763C15.0505 16.3813 14.9879 16.4412 14.9601 16.462C14.9323 16.4828 14.8579 16.526 14.7668 16.4764L12.0439 14.9948C11.9102 14.9221 11.7636 14.8857 11.6169 14.8857C11.4703 14.8857 11.3236 14.9221 11.19 14.9947L8.46708 16.4764C8.37594 16.526 8.30156 16.4828 8.27382 16.4619C8.24607 16.4411 8.18341 16.3812 8.20083 16.2762L8.72086 13.138C8.77193 12.8299 8.67331 12.5156 8.45697 12.2974L6.25408 10.0749C6.18036 10.0005 6.19704 9.91391 6.20767 9.88016C6.21824 9.84638 6.25392 9.76619 6.3558 9.75089L9.40007 9.29303C9.69893 9.24808 9.95725 9.0539 10.0909 8.7735L11.4524 5.91823C11.498 5.82268 11.5826 5.81236 11.6169 5.81236C11.6512 5.81236 11.7359 5.82265 11.7815 5.91823L13.143 8.77353C13.2767 9.05392 13.5349 9.24811 13.8338 9.29305L16.8781 9.75092C16.98 9.76622 17.0156 9.84641 17.0262 9.88019C17.0368 9.91397 17.0535 10.0005 16.9798 10.0749L14.7769 12.2974C14.5606 12.5156 14.462 12.8299 14.513 13.138Z"
          fill={color}
        />
        <path
          d="M15.9048 5.58294C15.7408 5.45964 15.5113 5.49727 15.3922 5.66699L15.0026 6.22197C14.8835 6.39169 14.9198 6.62927 15.0838 6.75258C15.149 6.80154 15.2244 6.82514 15.2992 6.82514C15.4128 6.82514 15.5246 6.77083 15.5964 6.66856L15.986 6.11357C16.1052 5.94383 16.0688 5.70625 15.9048 5.58294Z"
          fill={color}
        />
        <path
          d="M8.23007 6.21998L7.84047 5.66499C7.72136 5.49533 7.49185 5.4577 7.32782 5.58095C7.16385 5.70425 7.12749 5.94184 7.24663 6.11155L7.63623 6.66654C7.70805 6.76889 7.81995 6.82318 7.93348 6.82318C8.0083 6.82318 8.08379 6.79958 8.1489 6.75058C8.31287 6.6273 8.34923 6.38972 8.23007 6.21998Z"
          fill={color}
        />
        <path
          d="M6.00779 13.5762C5.94515 13.3766 5.73811 13.2675 5.54531 13.3323L4.91495 13.5443C4.72215 13.6091 4.61668 13.8235 4.67932 14.023C4.7297 14.1835 4.87359 14.2856 5.02829 14.2856C5.06587 14.2856 5.10411 14.2796 5.1418 14.2669L5.77216 14.0548C5.96494 13.99 6.07043 13.7757 6.00779 13.5762Z"
          fill={color}
        />
        <path
          d="M11.617 17.7942C11.4143 17.7942 11.25 17.9643 11.25 18.1741V18.8601C11.25 19.0699 11.4143 19.2399 11.617 19.2399C11.8197 19.2399 11.984 19.0699 11.984 18.8601V18.1741C11.984 17.9642 11.8197 17.7942 11.617 17.7942Z"
          fill={color}
        />
        <path
          d="M18.3203 13.5443L17.6899 13.3323C17.4972 13.2675 17.29 13.3767 17.2274 13.5762C17.1648 13.7757 17.2703 13.99 17.4631 14.0549L18.0934 14.2669C18.1311 14.2795 18.1693 14.2855 18.2069 14.2855C18.3616 14.2855 18.5055 14.1835 18.5559 14.023C18.6185 13.8235 18.512 13.6091 18.3203 13.5443Z"
          fill={color}
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_449_2841">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_449_2841">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default FioFidCardIcon;
